module.exports = __webpack_public_path__ + "media/images/contact-bg-1440-d74e1f2431f2c7a5a951e368e5927b51.png";